export class KernelScheduler {
    #clock;
    #jobs = new Map();
    #isShutdown = false;
    constructor(clock) {
        this.#clock = clock;
    }
    cancel(name) {
        const state = this.#jobs.get(name);
        if (state === undefined)
            return;
        this.#jobs.delete(name);
        this.#cancelWake(state);
        state.active = false;
    }
    register(job) {
        if (this.#isShutdown)
            throw new Error("The kernel scheduler is shut down");
        if (this.#jobs.has(job.name))
            throw new Error(`A scheduled job named ${job.name} is already registered`);
        const state = {
            active: true,
            job,
            running: false,
            wake: undefined,
            wakeToken: undefined,
        };
        this.#jobs.set(job.name, state);
        this.#arm(state, job.dueAt);
    }
    async shutdown() {
        if (this.#isShutdown)
            return;
        this.#isShutdown = true;
        for (const state of this.#jobs.values()) {
            this.#cancelWake(state);
            state.active = false;
        }
        this.#jobs.clear();
    }
    #arm(state, dueAt) {
        if (!state.active || this.#isShutdown)
            return;
        this.#cancelWake(state);
        const wakeToken = Symbol(state.job.name);
        state.wakeToken = wakeToken;
        state.wake = this.#clock.wakeAt(dueAt, () => {
            if (!state.active || this.#isShutdown || state.wakeToken !== wakeToken)
                return;
            state.wake = undefined;
            state.wakeToken = undefined;
            void this.#run(state);
        });
    }
    #cancelWake(state) {
        state.wakeToken = undefined;
        state.wake?.cancel();
        state.wake = undefined;
    }
    async #run(state) {
        if (!state.active || this.#isShutdown || state.running)
            return;
        state.running = true;
        try {
            await state.job.run();
        }
        catch {
            // A failed recurring job remains eligible for its next scheduled wake.
        }
        finally {
            state.running = false;
            if (state.active && !this.#isShutdown && state.job.cadenceMs !== undefined) {
                this.#arm(state, new Date(Date.parse(this.#clock.now()) + state.job.cadenceMs).toISOString());
            }
        }
    }
}
//# sourceMappingURL=kernel-scheduler.js.map